<script setup lang="ts">
import UiStickyBar from '@/features/UserInterface/components/UiStickyBar.vue';
import UiLink from '@/features/UserInterface/components/UiLink.vue';
import { ref } from 'vue';

export type StickyBannerProps = {
  sessionKey?: string;
  message: string;
  link?: {
    text: string;
    to: string;
  };
};

const { sessionKey, message, link } = defineProps<StickyBannerProps>();

const active = ref(sessionStorage.getItem(sessionKey) !== 'true');

const dismiss = () => {
  sessionStorage.setItem(sessionKey, 'true');
  active.value = false;
};
</script>

<template>
  <UiStickyBar position="bottom" :z-index="51" v-model:active="active" class="sticky-banner">
    <template #body>
      <div class="sticky-banner__body">
        <div class="sticky-banner__text">
          <p>{{ message }}</p>

          <UiLink :to="link.to" class="sticky-banner__link" @click="dismiss">
            {{ link.text }}
          </UiLink>
        </div>

        <button class="sticky-banner__close" aria-label="Dismiss notice" @click="dismiss">
          &#x2715;
        </button>
      </div>
    </template>
  </UiStickyBar>
</template>

<style lang="scss" scoped>
.sticky-banner {
  background-color: rgb(var(--link));
  color: rgb(var(--white));
  &__body {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 0.75rem 1rem;
    width: 100%;
    max-width: 700px;
    margin: 0 auto;
    box-sizing: border-box;
  }
  &__text {
    flex: 1;
    @include body-text(0.875rem);
  }
  &__link {
    color: currentColor;
    text-decoration: underline;
  }
  &__close {
    background: none;
    border: none;
    color: currentColor;
    cursor: pointer;
    font-size: 1.25rem;
    line-height: 1;
    padding: 0.25rem;
    flex-shrink: 0;
  }
}
</style>
